/**
 * A tiny cross-component signal that fires when a page's head metadata (title +
 * tags) has been applied to the document. Analytics (`GTMPageView`) listens for
 * it so a `page_view` reports the FINAL per-page title even on routes whose
 * `PageHead` only renders after an async fetch — route-change timing alone is
 * not enough because the title isn't known yet at navigation.
 */
export const SEO_HEAD_APPLIED_EVENT = "seo:head-applied";

/** Fire the head-applied signal (no-op outside the browser). */
export const notifyHeadApplied = (title?: string): void => {
    if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return;
    const detail = {
        title: title ?? (typeof document !== "undefined" ? document.title : ""),
    };
    window.dispatchEvent(new CustomEvent(SEO_HEAD_APPLIED_EVENT, { detail }));
};
